import { render, staticRenderFns } from "./AddProgramService.vue?vue&type=template&id=39b2fa90&scoped=true"
import script from "./AddProgramService.vue?vue&type=script&lang=js"
export * from "./AddProgramService.vue?vue&type=script&lang=js"
import style0 from "./AddProgramService.vue?vue&type=style&index=0&id=39b2fa90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2fa90",
  null
  
)

export default component.exports